import { render, staticRenderFns } from "./AnchorButton.vue?vue&type=template&id=453dc22d&scoped=true"
import script from "./AnchorButton.vue?vue&type=script&lang=js"
export * from "./AnchorButton.vue?vue&type=script&lang=js"
import style0 from "./AnchorButton.vue?vue&type=style&index=0&id=453dc22d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453dc22d",
  null
  
)

export default component.exports